import { api } from '@services';
import Tag, { ITag, ITagApiModel } from '@models/Tag.model';

interface IRequest {
  tagsIds: string[];
  equipmentId?: string;
  softwareId?: string;
  miscellaneousId?: string;
  studioServiceId?: string;
}
export interface IAddTagsToEquipmentVariables {
  data: IRequest;
}

export const addTagsToInventoryItem = async ({
  data,
}: IAddTagsToEquipmentVariables): Promise<ITag[]> => {
  const { data: tags } = await api.put<ITagApiModel[]>(
    `/tags/inventory/addTags`,
    data,
  );
  return Tag.arrayFromApiModel(tags);
};
